/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIType
 */
export interface APIType {
    /**
     * 
     * @type {string}
     * @memberof APIType
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIType
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIType
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIType
     */
    name: string;
}

/**
 * Check if a given object implements the APIType interface.
 */
export function instanceOfAPIType(value: object): value is APIType {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APITypeFromJSON(json: any): APIType {
    return APITypeFromJSONTyped(json, false);
}

export function APITypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIType {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APITypeToJSON(value?: Omit<APIType, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

